import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReportSortBy } from '@ndt/report-output/shared/models/sort-by-report-parameter';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { ReportParameterComponent } from '../../report-parameter-list/report-parameter-component';
import { ReportParameterConfig } from '../../report-parameter-list/report-parameter.config';

@Component({
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: SortByReportParameterComponent }],
    selector: 'ndt-sort-by-report-parameter',
    templateUrl: './sort-by-report-parameter.component.html',
    standalone: false
})
export class SortByReportParameterComponent implements OnDestroy, AfterViewInit, ReportParameterComponent {
   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   config: ReportParameterConfig;

   sortBy = Object.values(ReportSortBy);

   constructor() {
      this.form = new UntypedFormGroup({
         value: new UntypedFormControl(ReportSortBy.Duration),
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   ngAfterViewInit(): void {
      this.form.controls.isAskParameter?.valueChanges.pipe(delay(0), takeUntil(this.destroyed$)).subscribe(() => {
         this.form.controls.SortBy?.updateValueAndValidity();
      });
   }

   sortByDisplayWith(option: ReportSortBy): string {
      return `${option ?? ''}`;
   }
}
